import axios from 'axios'
import { z } from 'zod'
import { ProgramCategorySchema } from './schema'

type GETProgramCatalogParams = {
  programId: number
}

export async function GETProgramCatalogCategories(
  params: GETProgramCatalogParams
) {
  const response = await axios.get(
    `programs/${params.programId}/item_categories`,
    {
      params: {
        status: 'all',
      },
    }
  )

  return z.array(ProgramCategorySchema).parse(response.data)
}

interface ProgramItem {
  service_fee: number
  global_item_id: number
}

export interface PostProgramCatalogCategoryPayload {
  global_item_category_id: number
  service_fee: number
  apply_service_fee_to_items: 1 | 0
  program_items: ProgramItem[]
}
export async function POSTProgramCatalogCategory(
  programId: number,
  payload: PostProgramCatalogCategoryPayload
) {
  const response = await axios.post(
    `/programs/${programId}/item_categories`,
    payload
  )

  return response
}

export type PostProgramCatalogItemPayload = {
  global_item_category_id: number
  global_item_id: number
  service_fee: number
  programId: number
}

export async function POSTProgramCatalogItem(
  payload: PostProgramCatalogItemPayload
) {
  const response = await axios.post(
    `/programs/${payload.programId}/items`,
    payload
  )

  return response
}

export type DisableProgramCatalogItemPayload = {
  programId: number
  itemId: number
}

export async function DISABLEProgramCatalogItem(
  payload: DisableProgramCatalogItemPayload
) {
  const { programId, itemId } = payload
  const response = await axios.delete(`/programs/${programId}/items/${itemId}`)
  return response.data
}

export type PUTProgramItemPayload = {
  programId: number
  itemId: number
  service_fee?: number
  status?: 0 | 1
}
export async function PUTProgramItem(payload: PUTProgramItemPayload) {
  const { programId, itemId } = payload
  const response = await axios.put(`/programs/${programId}/items/${itemId}`, {
    service_fee: payload.service_fee,
    status: payload.status,
  })
  return response.data
}

export type PUTProgramCatalogCategoryPayload = {
  programId: number
  categoryId: number
  service_fee?: number
  status?: 0 | 1
  apply_service_fee_to_items?: 1 | 0
}

export async function PUTProgramCatalogCategory(
  payload: PUTProgramCatalogCategoryPayload
) {
  const { programId, categoryId } = payload
  const response = await axios.put(
    `/programs/${programId}/item_categories/${categoryId}`,
    payload
  )

  return response
}

export type DisableProgramCatalogCategory = {
  programId: number
  categoryId: number
}

export async function DISABLEProgramCatalogCategory(
  payload: DisableProgramCatalogCategory
) {
  const { categoryId, programId } = payload
  const response = await axios.delete(
    `/programs/${programId}/item_categories/${categoryId}`
  )
  return response.data
}
